export default "<abw-page-builder-barcode-design [model]=\"model\" [value]=\"model.value\"></abw-page-builder-barcode-design>";